module.exports = __webpack_public_path__ + "img/app-store.49159294.png";